import { Box } from '@mui/material';
import checkIcon from '../../../assets/images/checkIcon.png';
// import goldCheckIcon from '../../../assets/images/goldCheck.png';
// import prodCheckIcon from '../../../assets/images/prodCheck.png';
import CheckIcon from '@mui/icons-material/Check';
import editIcon from '../../../assets/images/editIcon.png';
import PendingIcon from '@mui/icons-material/Pending';
import notificationsGrayIcon from '../../../assets/images/notificationsGrayIcon.png';
import './SPUserCard.scss';
import { RemoveUserConfirmation } from './RemoveUserConfirmation/RemoveUserConfirmation';
import { EditUserProfile } from './EditUserProfile/EditUserProfile';
import { EditNotifications } from './EditNotifications/EditNotifications';
import { EditApiCredentials } from './EditApiCredentials/EditApiCredentials';
import { useEffect, useRef, useState } from 'react';
import {
  doFormErrorMsgs,
  showAPIerror
} from '../../../pages/SellerProfile/APIs/Helpers';
import SPQuestionnaire from './SPQuestionnaire/SPQuestionnaire';
import getSellerAndUserIDs from '../../../pages/SellerProfile/APIs/GetSellerUserIDs';
import { useTranslation } from 'react-i18next';
import { setIndUserData, fetchgetIndUser, deleteUserStart,
  resetRemovingSuccess,setShowSuccessPopUp,setModalType ,setFilterUsers,
  setApiStatus} from '../../../redux/slices/sellerProfileSlice';
import { useDispatch, useSelector } from 'react-redux';
import { fetchIndNotifsStart, setCurr_user_id, setSelectedItem } from '../../../redux/slices/notificationSlice';
import { QuestionnaireWithAnswerStart } from '../../../redux/slices/questionnaireSlice';

function SPUserCard({ cardType = '', filter = ['', 'All'] }) {
  const dispatch = useDispatch();
  const popupRef = useRef(null) as any;
  const [isPostQuestionnaire, setIsPostQuestionnaire] = useState(false);
  const [removeError, setRemoveError] = useState('');
  //const [modalDataLoaded, setModalDataLoaded] = useState(false);
  const [user_id, setUser_id] = useState('');


  const { t, i18n } = useTranslation();
  const { modalDataLoaded2, removingUser, users, removeSuccess,spPageText,modalType ,filterUsers,isAdmin} = useSelector((state: any) => state.sellerProfile);
  const { notificationRecipients, curr_user_id, modalDataLoaded1, selectedItem } = useSelector((state: any) => state.notification);
  const { postQuestionnaire, questionnaireForm } = useSelector((state: any) => state.questionnaire);
  const { modalDataLoaded4 } = useSelector((state: any) => state.apiCredential);

  const successMsg = t('sellerProfile.dashboard.removeUserSuccess');
  
  useEffect(()=>{
    if( removeSuccess){
     dispatch(setShowSuccessPopUp(successMsg));

     dispatch(setModalType(''));
      dispatch(resetRemovingSuccess(false));
    }
     // eslint-disable-next-line react-hooks/exhaustive-deps
  },[removeSuccess]);


  let userList =
    cardType === 'notifications'
      ? notificationRecipients
      : users;
  const onCloseRemoveConfirmation = async (isConfirmed) => {
    if (isConfirmed) {
      try {
        dispatch(deleteUserStart({ curr_user_id }))
      } catch (error) {
        console.log('ERROR in remove User', error);
        setRemoveError(t('sellerProfile.dashboard.errorRemoveUser') || '');
      }
    } else {
      setRemoveError('');
      dispatch(setModalType('EditUserProfile'));
    }
  };

  const onRemoveUserProfile = () => {
    dispatch(setModalType('RemoveUserConfirmation'));
    window.scrollBy({
      top: -300,
      left: 0,
      behavior: 'smooth'
    });
  };

  const onClickEditButton = async (event, index, curr_user_id) => {
    event.preventDefault();
    dispatch(setSelectedItem(index));
    dispatch(setCurr_user_id(curr_user_id));
   // setModalDataLoaded(false);
    switch (cardType) {
      case 'notifications':
        try {
          dispatch(fetchIndNotifsStart({ curr_user_id }));
        dispatch(setModalType('EditNotifications'));
        } catch (error) {
          doFormErrorMsgs(error, dispatch, spPageText);
          dispatch(setShowSuccessPopUp({
            message: t('sellerProfile.dashboard.errorGeneral'),
            successType: 'error'
          }));
        };
        break;

      case 'access':
        try {
          dispatch(fetchgetIndUser({ curr_user_id }));
         dispatch(setModalType('EditUserProfile'));
          dispatch(setIndUserData([...users]));
        } catch (error) {
          doFormErrorMsgs(error, dispatch, spPageText);
        }
        break;
      case 'env':
       dispatch(setModalType('EditApiCredentials'));
        //setModalDataLoaded(true);
        break;
      default:
       dispatch(setModalType(''));
        setRemoveError('');
    }
  }


  useEffect(() => {
    dispatch(setFilterUsers(''));
    popupRef.current &&
      popupRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest'
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const closePopup = () => {
   dispatch(setModalType(''));
    setRemoveError('');
  };

  const checkShowUserType = (user) => {
    if (cardType === 'access') {
      return ['USR001', 'USR002'].includes(user.role_id);
    }
    if (cardType === 'notifications') {
      return user.role === 'Contact' || user.role === 'Admin';
    }
    if (cardType === 'env') {
      return user.role_id === 'USR001';
    }
  };
  let countShow = 0;

  useEffect(() => {
    //get and set user_id and seller_id
    const getSellerUserIDs = () => {
      if (user_id === '') {
        getSellerAndUserIDs(['user_id'], [setUser_id],spPageText)
          .then((res) => res)
          .catch((err) => showAPIerror(err, setShowSuccessPopUp,spPageText,setApiStatus, 'getSellerUserIDs'));
      }
    };
    getSellerUserIDs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  useEffect(() => {
    const getQuestion = async (userId) => {
      try {
        const res = dispatch(QuestionnaireWithAnswerStart({ language: i18n.language, userId }))
        if (res) {
          if (postQuestionnaire) {
            setIsPostQuestionnaire(true);
          } else {
            setIsPostQuestionnaire(false);
          }
        }
      } catch (error) {
        console.log(error);
      }
    };
    if (user_id) {
      getQuestion(user_id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user_id, i18n.language]);


  const getQuestion = async (userId) => {
    try {
      const res = dispatch(QuestionnaireWithAnswerStart({ language: i18n.language, userId }))
      if (res) {
        if (postQuestionnaire) {
          setIsPostQuestionnaire(true);
        } else {
          setIsPostQuestionnaire(false);
        }
      }
    } catch (error) {
      console.log(error);
    }

  };
  
  return (
    <div>
      {userList.map((user, i) => {
        const showNotifRecip = () => {
          return filter[1] === 'All'
            ? true
            : user[filter[0]]?.includes(filter[1]);
        };
        const fullName = `${user.user_first_name} ${user.user_last_name}}`;
        const showUser = fullName
          .toLowerCase()
          .includes(filterUsers.toLowerCase());
        showUser && countShow++;

        return (
          ((showUser && cardType === 'access') ||
            (showUser && showNotifRecip() && cardType === 'notifications') ||
            (cardType === 'env' &&
              user.role_id === 'USR001' &&
              user.user_approved === 1)) &&
          checkShowUserType(user) && (
            // Default card structure
            <div
              className="userCardAndPopupContainer"
              key={`${user.lastName}-${i}`}
            >
              <div
                className={`popupClose  ${modalType !== '' && 'showPopupClose'
                  }`}
                onClick={() => closePopup()}
              ></div>
              <Box className="addEditUserCardContainer" key={`${user}-${i}`}>
                <div className="cardDescription">
                  <h2 className="userName">
                    {user.user_first_name} {user.user_last_name}
                  </h2>
                  <p
                    className={
                      user.role_id?.includes('USR001') ? 'admin' : 'user'
                    }
                  >
                    {user.role_id
                      ? spPageText[user.role_id]
                      : spPageText[user.role.toLowerCase()]}

                    {user.sub_role_type_id
                      ? ` - ${spPageText[user.sub_role_type_id]}`
                      : null}
                  </p>
                </div>
                {/* USER LIST PAGE  */}
                <div className="cardBody">
                  {user.additional_access_id && cardType === 'access' && (
                    <div className="userAccesses">
                      {user.additional_access_id.map((service) => (
                        <div
                          className="accessDescription"
                          key={`${service}-${i}`}
                        >
                          {user.user_approved !== 0 && (
                            <>
                              {' '}
                              <img
                                className="checkIcon"
                                src={checkIcon}
                                alt="Check Icon"
                              />{' '}
                              <p className="service">
                                {spPageText[service]}
                              </p>
                            </>
                          )}
                        </div>
                      ))}
                      {user.additional_access_id.length > 0 &&
                        user.user_approved === 0 && (
                          <>
                            <PendingIcon
                              sx={{
                                marginRight: '8px',
                                fontSize: '24px',
                                opacity: '0.8'
                              }}
                            />
                            {t('sellerProfile.dashboard.pending')}
                          </>
                        )}
                      {user.additional_access === null &&
                        user.user_approved === 0 && (
                          <>
                            <PendingIcon
                              sx={{
                                marginRight: '8px',
                                fontSize: '24px',
                                opacity: '0.8'
                              }}
                            />
                            {t('sellerProfile.dashboard.pending')}
                          </>
                        )}
                    </div>
                  )}

                  {/* API CREDENTIALS PAGE*/}
                  {cardType === 'env' && (
                    <div className="userAccesses">
                      {user?.env?.length && [...user.env]?.sort((a,b)=>{const order = ['UAT', 'BAT', 'Prod'];
                        return order.indexOf(a) - order.indexOf(b);
                      }).map((service, ii) => (
                        <div
                          className="accessDescription"
                          key={`${service}-${ii}`}
                          id={`${service}`}
                        >
                          {service === 'UAT' ? (
                            <CheckIcon sx={{color:'#E17000'}}/>
                          ) : service === 'BAT' ? (
                            <CheckIcon sx={{color:'#00778F'}}/>
                          ) :  service === 'Prod' ? (
                            <CheckIcon sx={{color:'#20842F'}}/>
                          ): (
                            <img
                              className="checkIcon"
                              src={checkIcon}
                              alt="Check Icon"
                            />
                          )}
                          <p className="service">{service}</p>
                        </div>
                      ))}
                    </div>
                  )}
                  {/* NOTIFICATIONS PAGE (Note "count" contains an array of  notification IDs*/}
                  {user.count &&
                    cardType === 'notifications' &&
                    isAdmin && (
                      <div className="userNotification">
                        <div className="notification">
                          <img
                            className="notificationIcon"
                            src={notificationsGrayIcon}
                            alt="Notification Icon"
                          />
                          <p className="notificationNum">
                            {user.count.split(',').length || 0}/3
                          </p>
                        </div>
                      </div>
                    )}
                  {/* SHOW EDIT BUTTONS ON ALL CARD TYPES when applicable */}
                  {((cardType === 'access' && isAdmin) ||
                    cardType !== 'access') && (
                      <div
                        className="editUser"
                        onClick={(e) => onClickEditButton(e, i, user.user_id)}
                        onKeyDown={(e) =>
                          e.key === 'Enter' && onClickEditButton(e, i, user.user_id)
                        }
                        tabIndex={0}
                      >
                        <img
                          className="editIcon"
                          src={editIcon}
                          alt="Edit Icon"
                        />
                      </div>
                    )}
                </div>
              </Box>
              {modalDataLoaded1 &&
              modalType === 'EditNotifications' &&
                selectedItem === i && (
                  <div className="popupContainer" ref={popupRef}>
                    <EditNotifications
                      email={user.user_email}
                      curr_user_id={curr_user_id}
                      hasMandatory={user.notificationsMandatory === 1}
                    />
                  </div>
                )}

              {modalDataLoaded2 &&
                modalType === 'EditUserProfile' &&
                selectedItem === i && (
                  <div className="popupContainer" ref={popupRef}>
                    <EditUserProfile
                      onRemove={onRemoveUserProfile}
                      curr_user_id={curr_user_id}
                    />
                  </div>
                )}
              {modalDataLoaded4 &&
                modalType === 'EditApiCredentials' &&
                selectedItem === i && (
                  <div className="popupContainer" ref={popupRef}>
                    <EditApiCredentials
                      email={user.user_email}
                      curr_user_id={curr_user_id}
                    />
                  </div>
                )}

              {modalDataLoaded2 &&
                modalType === 'RemoveUserConfirmation' &&
                selectedItem === i && (
                  <div className="popupContainer">
                    <RemoveUserConfirmation
                      onClose={onCloseRemoveConfirmation}
                      order={selectedItem}
                      error={removeError}
                      removeSubmission={removingUser}
                    />
                  </div>
                )}
            </div>
          )
        );
      })}
      {cardType === 'env' ? (
        <SPQuestionnaire
          questionnaireFormData={questionnaireForm}
          getQuestion={getQuestion}
          user_id={user_id}
          isPostQuestionnaire={isPostQuestionnaire}
        />
      ) : (
        <></>
      )}
      {countShow === 0 && (
        <div
          className="noUsersFound"
          dangerouslySetInnerHTML={{
            __html: spPageText[`noMatchesFound${cardType}`]
          }}
        ></div>
      )}
      <div className={`forcePageScroll ${modalType}`}></div>
    </div>
  );
}

export default SPUserCard;